/**
 * A class that signifies that an employee would prefer not to work on a specific day.
 */
import { asDayOfWeek, DayOfWeek } from '../../enums/DayOfWeek';
import moment from 'moment';
import { AbstractPreferredTimeOff } from './AbstractPreferredTimeOff';

export class TemporaryPreferredTimeOff extends AbstractPreferredTimeOff {
  reason: string;
  startTime: string;
  endTime: string;
  date: string;
  dayOfWeek: DayOfWeek;

  /**
   * @param reason the human readable-reason, why the employee would prefer not to be working this day.
   * @param startTime the beginning of the period where the setting applies.
   * @param endTime the end of the period where the setting applies.
   * @param date the date on which the employee would prefer not to work.
   */
  constructor(
    reason: string,
    startTime: string,
    endTime: string,
    date: string,
  ) {
    const dayOfWeek = asDayOfWeek(moment(date, 'YYYY-MM-DD'));
    super(dayOfWeek, reason, startTime, endTime);
    this.date = date;
  }

  getFormattedDate(): string {
    return moment(this.date).format('ddd, DD MMM');
  }
}
